import { createFileRoute } from "@tanstack/react-router";

import { loadMe } from "../features/auth/session";
import { LandingPage } from "../features/marketing/LandingPage";
import { PublicLayout } from "../features/marketing/PublicLayout";

export const Route = createFileRoute("/")({
  staticData: { publicShell: true },
  loader: ({ context }) => loadMe(context.queryClient),
  component: HomePage,
});

function HomePage() {
  const me = Route.useLoaderData();
  return (
    <PublicLayout signedIn={me !== null}>
      <LandingPage signedIn={me !== null} />
    </PublicLayout>
  );
}
